(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('.wg-card')];
    const more = root.querySelector('.wg-more'), count = root.querySelector('.wg-count');
    let imageRequest = 0;
    const loading = root.querySelector('.wg-loading');
    const dialog = root.querySelector('dialog'), video = root.querySelector('video');
    let image = root.querySelector('.wg-large');
    let shown = 24, current = 0, opener = null, scrollBefore = '';
    function render() {
      cards.forEach((card, i) => { card.hidden = i >= shown; });
      count.textContent = `${Math.min(shown, cards.length)} / ${cards.length} 件`;
      more.hidden = shown >= cards.length;
    }
    render(); root.classList.add('wg-ready');
    more.addEventListener('click', () => {
      const first = shown; shown += 24; render(); cards[first]?.focus({preventScroll:true});
    });
    function display(index) {
      current = index; const card = cards[current], src = card.querySelector('img');
      const request = ++imageRequest;
      image.hidden = true;
      image.removeAttribute('src');
      image.onload = null; image.onerror = null;
      video.pause(); video.removeAttribute('src'); video.load();
      video.hidden = !card.dataset.video;
      loading.hidden = !!card.dataset.video;
      loading.textContent = '写真を読み込んでいます…';
      if (card.dataset.video) { video.src = card.dataset.video; video.poster = card.href; }
      else {
        // A fresh element prevents the browser from retaining the previous bitmap.
        const next = image.cloneNode(false);
        next.alt = src.alt;
        next.onload = async () => {
          try { await next.decode(); } catch (_) {}
          if (request !== imageRequest) return;
          loading.hidden = true; next.hidden = false;
        };
        next.onerror = () => {
          if (request !== imageRequest) return;
          loading.textContent = '写真を読み込めませんでした。前後の矢印で選び直してください。';
        };
        image.replaceWith(next); image = next; next.src = card.href;
      }
      root.querySelector('#wg-dialog-title').textContent = '制作実例';
      root.querySelector('.wg-position').textContent = `${current + 1} / ${cards.length}`;
      root.querySelector('.wg-prev').disabled = current === 0;
      root.querySelector('.wg-next').disabled = current === cards.length - 1;
    }
    function open(index, source) {
      opener = source; display(index);
      if (!dialog.open) { scrollBefore = document.body.style.overflow; document.body.style.overflow = 'hidden'; dialog.showModal(); }
    }
    root.addEventListener('click', e => {
      const card = e.target.closest('.wg-card');
      if (!card || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault(); open(cards.indexOf(card), card);
    });
    root.querySelector('.wg-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { video.pause(); video.removeAttribute('src');video.load();document.body.style.overflow = scrollBefore;opener?.focus({preventScroll:true}); });
    dialog.addEventListener('click', e => { if(e.target === dialog){ const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close(); } });
    root.querySelector('.wg-prev').addEventListener('click', () => display(Math.max(0,current-1)));
    root.querySelector('.wg-next').addEventListener('click', () => display(Math.min(cards.length-1,current+1)));
    dialog.addEventListener('keydown', e => { if(e.target.matches('video,input'))return;if(e.key==='ArrowLeft'&&current>0){e.preventDefault();display(current-1);}if(e.key==='ArrowRight'&&current<cards.length-1){e.preventDefault();display(current+1);} });
    function fromHash() {
      const index=cards.findIndex(c=>`#${c.id}`===location.hash);
      if(index<0)return;shown=Math.max(shown,Math.ceil((index+1)/24)*24);render();open(index,cards[index]);
    }
    fromHash();window.addEventListener('hashchange',fromHash);
  }
  // Read the same published feed as the existing XO Gallery (gallery ID 2).
  const source = 'https://cdn.xotiny.com/assets/shop/ab9c6c-c1/2.json';
  function mediaURL(value) {
    try {
      const url = new URL(value);
      return url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' ? url.href : '';
    } catch (_) { return ''; }
  }
  function createCard(item) {
    const href = mediaURL(item.url);
    if (!href || !['IMAGE', 'VIDEO'].includes(item.type)) return null;
    const card = document.createElement('a');
    card.className = 'wg-card'; card.id = `work-${item._id}`;
    card.dataset.work = item._id; card.dataset.video = item.type === 'VIDEO' ? mediaURL(item.video) : '';
    card.href = href; card.setAttribute('aria-label', '制作実例を拡大');
    const photo = document.createElement('span'); photo.className = 'wg-photo';
    const img = document.createElement('img');
    const thumb = new URL(href); thumb.searchParams.set('width', '600');
    img.src = thumb.href; img.alt = item.alt?.ja || item.alt?.en || '';
    img.width = Number(item.w) || 1080; img.height = Number(item.h) || 1350;
    img.loading = 'lazy'; img.decoding = 'async'; photo.append(img);
    const caption = document.createElement('span'); caption.className = 'wg-caption';
    const label = document.createElement('span'); label.setAttribute('aria-hidden', 'true');
    label.textContent = card.dataset.video ? '動画 ▶' : '拡大 ＋'; caption.append(label);
    card.append(photo, caption); return card;
  }
  async function load(root) {
    if (root.dataset.fetching === 'true' || root.dataset.ready) return;
    root.dataset.fetching = 'true';
    const grid = root.querySelector('.wg-grid'), status = root.querySelector('.wg-source-status');
    const retry = root.querySelector('.wg-retry');
    retry.hidden = true; status.hidden = false; status.textContent = '制作実例を読み込んでいます…';
    grid.setAttribute('aria-busy', 'true');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(source, {signal: controller.signal, cache: 'no-cache', credentials: 'omit'});
      if (!response.ok) throw new Error('Gallery unavailable');
      const data = await response.json();
      if (!Array.isArray(data.images)) throw new Error('Invalid gallery data');
      const fragment = document.createDocumentFragment();
      data.images.forEach(item => { const card = createCard(item); if (card) fragment.append(card); });
      grid.replaceChildren(fragment); status.hidden = true;
      init(root);
      if (!grid.children.length) { status.hidden = false; status.textContent = '現在、掲載中の制作実例はありません。'; }
    } catch (_) {
      status.textContent = '全作品を読み込めませんでした。表示中の作品はご覧いただけます。再読み込みをお試しください。';
      retry.hidden = false;
      retry.onclick = () => load(root);
    } finally {
      clearTimeout(timeout); root.dataset.fetching = 'false'; grid.setAttribute('aria-busy', 'false');
    }
  }
  document.querySelectorAll('[data-gallery]').forEach(load);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-gallery]').forEach(load));
})();
